/**
 * @memberof feature-references
 * @enum {string}
 * @property {string} SPATIAL_QUERY
 */
var FeatureReferenceQueryPatternType;
(function (FeatureReferenceQueryPatternType) {
    FeatureReferenceQueryPatternType["INHERIT"] = "INHERIT";
    FeatureReferenceQueryPatternType["SPATIAL_QUERY"] = "SPATIAL_QUERY";
})(FeatureReferenceQueryPatternType || (FeatureReferenceQueryPatternType = {}));
export default FeatureReferenceQueryPatternType;
